import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Aviso } from '../models';

@Injectable({
  providedIn: 'root',
})
export class CelotexService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiNexus}/v1/celotex`;

  listar(): Observable<Aviso[]> {
    return this.http.get<Aviso[]>(this.baseUrl);
  }
}
